import { FormattedMessage } from 'react-intl';
import PropTypes from 'prop-types';
import React from 'react';
import classNames from 'classnames';
import Isvg from 'react-inlinesvg';
import { ARROW_ICONS } from 'constants/icons';

import { messages } from './ControlsMessages';

export function CarouselPrev(props) {
  const { currentSlide, previousSlide } = props;

  const isOnFirstSlide = currentSlide === 0;

  return (
    <a
      className={classNames('carousel__localnav carousel__localnav--prev', {
        'carousel__localnav--disabled': isOnFirstSlide,
      })}
      onClick={previousSlide}>
      <FormattedMessage {...messages.previous} />
      <Isvg className="svg" uniquifyIDs={false} src={ARROW_ICONS.arrow} />
    </a>
  );
}

CarouselPrev.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  previousSlide: PropTypes.func.isRequired,
};

// eslint-disable-next-line react/no-multi-comp
export function CarouselNext(props) {
  const { slidesToScroll, slideCount, currentSlide, nextSlide, slidesToShow } = props;

  const isOnLastSlide = slidesToScroll + slidesToShow + currentSlide > slideCount;
  return (
    <a
      className={classNames('carousel__localnav carousel__localnav--next', {
        'carousel__localnav--disabled': isOnLastSlide,
      })}
      onClick={nextSlide}>
      <FormattedMessage {...messages.next} />
      <Isvg className="svg" uniquifyIDs={false} src={ARROW_ICONS.arrow} />
    </a>
  );
}

CarouselNext.propTypes = {
  currentSlide: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  nextSlide: PropTypes.func.isRequired,
  slidesToScroll: PropTypes.number.isRequired,
  slidesToShow: PropTypes.number.isRequired,
};

// eslint-disable-next-line react/no-multi-comp
export function Pagination(props) {
  const { slideCount, slidesToScroll, currentSlide, goToSlide } = props;

  const indexes = [];
  for (let page = 0; page < slideCount; page += slidesToScroll) {
    indexes.push(page);
  }

  return (
    <ul className="carousel__pagination">
      {indexes.map(index => (
        <li
          key={index}
          className={classNames('carousel__pagination__page', {
            selected: currentSlide === index,
          })}>
          <a onClick={goToSlide.bind(null, index)}>{index}</a>
        </li>
      ))}
    </ul>
  );
}

Pagination.propTypes = {
  slidesToScroll: PropTypes.number.isRequired,
  slideCount: PropTypes.number.isRequired,
  currentSlide: PropTypes.number.isRequired,
  goToSlide: PropTypes.func.isRequired,
};
